import { createAction, createReducer, PayloadAction } from '@reduxjs/toolkit'
import { eventSetupTypes } from '../constants/eventsSetupTypes.constants'

export interface EventSetup {
    id: number
    title: string
    orderBy: number
    isOutcome: boolean
    isWarning: boolean
    isEnabled: boolean
    isEditableByHrOnly: boolean
    isDocumentVisible: boolean
    eventSetupDateTypeLookupId: number
    isTimeRecordingEnabled: boolean
}

interface EventsState {
    eventSetups: EventSetup[]
}

const initialState: EventsState = {
    eventSetups: [],
}

export const setEventsSetups = createAction<EventSetup[]>(
    eventSetupTypes.SET_EVENT_SETUPS
)

export const eventsReducer = createReducer(initialState, builder => {
    builder
        .addCase(
            setEventsSetups,
            (state, action: PayloadAction<EventSetup[]>) => {
                state.eventSetups = action.payload
            }
        )
        .addDefaultCase(() => {})
})
